import React from 'react';
import { useYouTubeData } from '../context/YouTubeContext';
import DecorativeLeaves from '../components/DecorativeLeaves';
import './CreatorsPage.css';

const owners = [
  {
    name: 'lafless',
    youtubeChannelId: 'UCGPH1e_50rim2UzE423havg',
    youtubeHandle: '@lafless',
    description: 'Owner of TheTopia and content creator known for chaotic Minecraft videos and custom coded events and mechanics.'
  },
  {
    name: 'Evakz',
    youtubeChannelId: 'UCVoAZNkP_3Vo61jUERpvzCQ',
    youtubeHandle: '@Evakz',
    description: "Owner of TheTopia and world's most handsome human. Reading memes by day, torturing people in Minecraft at night."
  }
];

export default function CreatorsPage() {
  const { youtubeData, loading } = useYouTubeData();

  const formatSubscriberCount = (count) => {
    if (!count) return '...';
    if (count >= 1000000) {
      return `${(count / 1000000).toFixed(2)}M`;
    } else if (count >= 1000) {
      return `${(count / 1000).toFixed(1)}K`;
    }
    return count.toString();
  };

  return (
    <section className="creators-page">
      <DecorativeLeaves config="creators" />
      <div className="creators-container">
        <div className="creators-header animate-fade-in">
          <h1 className="creators-title">Server Owners</h1>
          <p className="creators-subtitle">Meet the creators behind TheTopia</p>
        </div>

        <div className="creators-grid">
          {owners.map((owner, index) => {
            const ytData = youtubeData[owner.youtubeChannelId];
            return (
              <div key={owner.name} className={`creator-card-wrapper ${index === 0 ? 'first-card' : ''}`}>
                {index === 0 && (
                  <img src="/hes_cooler.png" alt="He's cooler" className="hes-cooler-img" />
                )}
                <div className={`creator-card animate-scale-in delay-${index + 1}`}>
                <div className="creator-header-section">
                  <div className="youtube-avatar">
                    <img
                      src={ytData?.thumbnailUrl || '/placeholder-avatar.png'}
                      alt={`${owner.name}'s profile`}
                    />
                  </div>
                  <div className="creator-titles">
                    <h2 className="creator-name">{owner.name}</h2>
                    <span className="creator-role">Owner</span>
                  </div>
                </div>

                <div className="creator-info">
                  <p className="creator-description">{owner.description}</p>

                  <div className="creator-stats">
                    <div className="stat-item youtube-stat">
                      <i className="mdi mdi-youtube"></i>
                      <span className="stat-value">
                        {loading ? '...' : formatSubscriberCount(ytData?.subscriberCount)}
                      </span>
                      <span className="stat-label">subscribers</span>
                    </div>
                  </div>

                  <div className="creator-actions">
                    <a
                      href={`https://youtube.com/${owner.youtubeHandle}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-primary"
                    >
                      <i className="mdi mdi-youtube"></i> YouTube
                    </a>
                  </div>
                </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
